/**
 * Kael Haus — Auto free sticker v5 (CHECKOUT-ONLY)
 * 2+ cases -> the free Hala sticker is ensured at the moment the customer
 * clicks Checkout. Below 2 cases -> any auto-added sticker is removed at
 * that same moment. The cart is NEVER mutated while the customer browses.
 *
 * WHY: /cart/add.js inserts new lines at the TOP of the cart, shifting
 * every line number — and this theme's drawer addresses items by line
 * number. Any background add/remove therefore makes the drawer's buttons
 * act on the wrong lines (symptoms: wrong item removed, counts stuck,
 * items "appearing"). The only safe mutation point is checkout click,
 * after which the drawer no longer matters.
 *
 * Back-from-checkout: the page is reloaded once (bfcache restore) so the
 * drawer reflects the sticker line accurately.
 *
 * Known gap: express wallet buttons skip the cart checkout path — cover
 * those orders with the fulfillment pack-in rule. Keep the "buy 2 cases
 * -> sticker free" automatic discount active or it rings up at full price.
 */
(function () {
  'use strict';
  if (window.__khAutoGiftBound) return;
  window.__khAutoGiftBound = true;

  const DEBUG = true;
  const log = (...a) => DEBUG && console.log('[auto-gift]', ...a);

  const GIFT_VARIANT_ID = 48294986776746; // The Hala Laptop Sticker — One Size
  const CASE_THRESHOLD = 2;

  const isTaggedGift = (i) => !!(i && i.properties && (i.properties._auto_gift || i.properties._gift));
  const isHala = (i) => i.variant_id === GIFT_VARIANT_ID;
  const isSticker = (i) => String(i.product_title || i.title || '').toLowerCase().includes('sticker');
  const countCases = (c) => c.items.reduce((n, i) => (!isTaggedGift(i) && !isSticker(i)) ? n + i.quantity : n, 0);

  const getCart = () => fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
  const post = (url, body) => fetch(url, {
    method: 'POST', credentials: 'same-origin', keepalive: true,
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  });

  /** Ensure the sticker line is correct. Runs ONLY on checkout click. */
  async function reconcile() {
    try {
      const cart = await getCart();
      if (!cart || !cart.items) return;
      const cases = countCases(cart);
      const tagged = cart.items.find((i) => isHala(i) && isTaggedGift(i));
      const untagged = cart.items.find((i) => isHala(i) && !isTaggedGift(i));
      const shouldHave = cases >= CASE_THRESHOLD;
      log('checkout reconcile | cases:', cases, '| gift:', !!tagged, '| untagged sticker:', !!untagged);

      if (shouldHave && !tagged && !untagged) {
        await post('/cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _auto_gift: 'free_sticker_2cases' } }] });
        log('added gift');
      } else if (!shouldHave && tagged) {
        await post('/cart/change.js', { id: tagged.key, quantity: 0 });
        log('removed gift');
      } else if (tagged && tagged.quantity !== 1) {
        await post('/cart/change.js', { id: tagged.key, quantity: 1 });
        log('pinned gift qty to 1');
      }
    } catch (e) {
      log('reconcile error', e);
    }
  }

  // ---- The ONLY mutation moment: checkout click ----
  let ensuring = false;
  document.addEventListener('click', function (e) {
    try {
      const btn = e.target && e.target.closest
        ? e.target.closest('button[name="checkout"], #checkout, .cart__checkout-button, a[href="/checkout"]')
        : null;
      if (!btn || ensuring) return;
      ensuring = true;
      e.preventDefault();
      e.stopPropagation();
      log('checkout click — reconciling gift first');
      let done = false;
      const proceed = () => {
        if (done) return;
        done = true;
        ensuring = false;
        window.location.href = '/checkout';
      };
      const cap = setTimeout(proceed, 3000); // never block checkout
      reconcile()
        .catch(() => {})
        .then(() => { clearTimeout(cap); proceed(); });
    } catch (err) {
      ensuring = false; // never block checkout on our own failure
    }
  }, true);

  // Back from checkout (bfcache restore): reload once so the drawer
  // matches the real cart (which may now contain the sticker line).
  window.addEventListener('pageshow', function (ev) {
    ensuring = false;
    if (ev.persisted) {
      log('restored from bfcache — reloading for cart accuracy');
      window.location.reload();
    }
  });
})();
